"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AosScroll_1 = __importDefault(require("./AosScroll"));
var ApplyForm_1 = __importDefault(require("./ApplyForm"));
var Cookie_1 = __importDefault(require("./Cookie"));
var swiper_1 = __importDefault(require("swiper"));
require("alpinejs");
window.initialData = function () {
    return {
        init: function (id) {
            var el = document.getElementById(id);
            if (el) {
                // @ts-ignore
                this.swiper = new swiper_1.default(el, {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                    loop: true,
                    breakpoints: {
                        768: {
                            slidesPerView: 'auto'
                        }
                    }
                });
            }
        }
    };
};
var App = /** @class */ (function () {
    function App() {
    }
    App.init = function () {
        Cookie_1.default.init();
        new AosScroll_1.default();
        new ApplyForm_1.default();
    };
    return App;
}());
document.addEventListener('DOMContentLoaded', function (event) {
    App.init();
});
